var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, injectable } from '@serviceos-rn/core';
import { ITipEventsRepositoryType } from '../ITipEventsRepository';
import { ITipRepositoryType } from '../ITipRepository';
import { IUpdateTipUseCaseType } from '../../../Interfaces/IUpdateTipUseCase';
import { ICoordinatorType } from '../../../Interfaces/ICoordinator';
import { parseChoiceItems } from '../../../../Helpers/ParseChoiceItems';
let ContinueUseCase = class ContinueUseCase {
    constructor(coordinator, repository, eventsRepository, updateTip) {
        this.coordinator = coordinator;
        this.repository = repository;
        this.eventsRepository = eventsRepository;
        this.updateTip = updateTip;
    }
    execute() {
        var _a;
        const choiceUpdate = {
            id: this.repository.tip.value.id,
            choice_items: parseChoiceItems(this.repository.tip.value.choice_items || [])
        };
        this.coordinator.getIsTipModal() && this.coordinator.dismissTip();
        (_a = this.updateTip) === null || _a === void 0 ? void 0 : _a.execute(this.repository.tip.value);
        return this.eventsRepository.sendDidFinishTipping(choiceUpdate);
    }
};
ContinueUseCase = __decorate([
    injectable(),
    __param(0, inject(ICoordinatorType)),
    __param(1, inject(ITipRepositoryType)),
    __param(2, inject(ITipEventsRepositoryType)),
    __param(3, inject(IUpdateTipUseCaseType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], ContinueUseCase);
export { ContinueUseCase };
